var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.801 116.641C202.724 98.1653 238.936 88.4382 275.797 88.4375C312.658 88.4368 348.871 98.1626 380.794 116.637C412.718 135.112 439.228 161.685 457.66 193.685C476.093 225.686 485.798 261.986 485.801 298.938H275.801L170.801 116.641Z",
    fill: "#F5BA33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.754 298.94L170.804 481.187C138.887 462.708 112.383 436.134 93.9571 404.135C75.5307 372.135 65.8301 335.838 65.8301 298.89C65.8301 261.942 75.5307 225.645 93.9571 193.646C112.383 161.646 138.887 135.072 170.804 116.594L275.754 298.94Z",
    fill: "#5DCDF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M485.751 298.945C485.734 335.885 476.021 372.171 457.588 404.157C439.155 436.143 412.649 462.704 380.735 481.171C348.821 499.639 312.62 509.362 275.771 509.366C238.921 509.369 202.719 499.652 170.801 481.191L275.801 298.895L485.751 298.945Z",
    fill: "#5FED6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.755 298.925L170.755 116.629C164.405 120.304 158.247 124.302 152.305 128.608C146.368 132.935 140.66 137.569 135.205 142.492L275.755 298.925Z",
    fill: "#FFFFF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275.751 298.934L170.801 481.18C177.14 484.859 183.665 488.205 190.351 491.204C197.151 494.212 204.001 496.818 210.851 499.074L275.751 298.934Z",
    fill: "#FFFFF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.754 298.929H485.754C485.742 284.225 484.218 269.562 481.204 255.172L275.754 298.929Z",
    fill: "#FFFFF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.9003c66837a0e7a62d9b0f24104f5439.svg";
export { ForwardRef as ReactComponent };